import {
  defineSchema,
  SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";

/** Context available to a CSAT survey email when a support ticket closes. */
export const supportCsatSurveySchema = defineSchema({
  fields: {
    surveyLink: {
      /* Url, not Text: the Button block only offers fields it can link to, so
         Text left the survey link unusable as a button — the one thing every
         CSAT email needs. */
      dataType: "Url",
      documentation:
        "Link to the customer satisfaction survey. Required in every CSAT email — without it the customer has no way to respond.",
    },
    customerName: {
      dataType: "Text",
      documentation: "The customer's name, for greeting them in the email.",
    },
    customerEmail: {
      dataType: "Text",
      documentation: "The email address the survey is being sent to.",
    },
    ticketId: {
      dataType: "Text",
      documentation: "The support ticket the survey is asking about.",
    },
    assigneeName: {
      dataType: "Text",
      documentation:
        "The agent who handled the ticket, for naming them in the email.",
    },
    storeName: {
      dataType: "Text",
      documentation: "The merchant's store name.",
    },
  },
});

export const exampleSupportCsatSurveySchemaInstance: SchemaInstance<
  typeof supportCsatSurveySchema
> = {
  surveyLink: "https://acme.myshopify.com/apps/redo/returns-portal/csat/cnv_1",
  customerName: "Jordan Rivera",
  customerEmail: "jordan@example.com",
  ticketId: "cnv_1",
  assigneeName: "Sam Chen",
  storeName: "Acme Supply Co.",
};
